import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';

//compont ui:
import DatePicker from '../components/utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
    FormControl,
    Select,
    InputLabel,
    Paper,
    Button,
} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';

//actions:
import { navigate, openDialog } from '../actions';

//helpers:
import { getData, postData } from '../dataLib';
import * as config from '../constants/configuration';

const styles = theme => ({
    containerView: {
        width: '83vw',
        height: '83vh',
        marginTop: 135,
    },
    paperCentroDia: {
        paddingTop: 0,
        paddingBottom: theme.spacing(1) / 2,
        paddingLeft: theme.spacing(1) / 2,
        paddingRight: theme.spacing(1) / 2,
        margin: theme.spacing(1),
    },
    form: {
        maxWidth: 650,
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 20,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 310,
        margin: 0,
        padding: 0,
    },
    spinnerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '20px !important',
        height: '20px !important',
    },
    textField: {
        width: 145,
        margin: 0,
        padding: 0,
    },
    acceptContainer: {
        width: '100%',
        display: 'flex',
    },
    button: {
        borderRadius: 0,
        marginLeft: 0,
        marginRight: 20,
        color: 'white',
        textTransform: 'capitalize',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class KDImportar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centro: this.props.centroDiaSelected.centro.id
                ? this.props.centroDiaSelected.centro.id
                : 1,
            centroDiaCierre: 1,
            date: null,
            lastExportDate: null,
        };
    }

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(''); //go to home page
            return;
        }
    }

    importAux = (concepto) => {
        const centro = 61;
        getData(
            'Contabilidad/UltimaExportacion?centro_id=' + centro,
            response => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: concepto,
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching last export date',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.containerView}>
                <Paper className={classes.paperCentroDia} elevation={0}>
                    <form className={classes.form}>
                        <div className={classes.acceptContainer}>
                            <Tooltip
                                title="Fecha en la que se realizó la última importación de movimientos de artículos"
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 500 }}
                                placement="right"
                                classes={{ tooltip: this.props.classes.tooltip }}
                            >
                                <FormControl>
                                    <DatePicker
                                        label="Última importación mov. articulos"
                                        value={new Date()}
                                        className={classes.textField}
                                        disabled
                                    />
                                </FormControl>
                            </Tooltip>
                        </div>
                        <div className={classes.acceptContainer}>
                            <Tooltip
                                title="Fecha en la que se realizó la última importación de movimientos de venta"
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 500 }}
                                placement="right"
                                classes={{ tooltip: this.props.classes.tooltip }}
                            >
                                <FormControl>
                                    <DatePicker
                                        label="Última importación mov. venta"
                                        value={new Date()}
                                        className={classes.textField}
                                        disabled
                                    />
                                </FormControl>
                            </Tooltip>
                        </div>
                    </form>
                    <form className={classes.form}>
                        <div className={classes.acceptContainer}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={this.props.isLoading ? true : false}
                                className={classes.button}
                                onClick={() => { this.importAux('Movimientos de artículos importados correctamente'); }}
                            >
                                Importar Movimientos Artículos Central Compras
                            </Button>
                        </div>
                        <div className={classes.acceptContainer}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={this.props.isLoading ? true : false}
                                className={classes.button}
                                onClick={() => { this.importAux('Movimientos de venta importados correctamente'); }}
                            >
                                Importar Movimientos Venta & Redemption
                            </Button>
                        </div>
                    </form>
                </Paper>
            </div>
        );
    }
}

KDImportar.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        isLoading: state.centros.isLoading,
        centroDiaSelected: state.centroDiaSelected,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators(
        {
            navigate,
            openDialog,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispathToProps,
)(withStyles(styles, { withTheme: true })(KDImportar));
